module.exports = __webpack_public_path__ + "img/cgtn.5026d8d3.jpg";